exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "body{font-size:13px;line-height:1.4}[data-primitive-type]:after,code{border-radius:2px;opacity:.8;padding:0 4px 1px;border-right:3px solid #fff}h4>code{background-color:#ffb6c1}[data-primitive-type]:after{background-color:#87cefa;content:attr(data-primitive-type);font-family:monospace}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./css/styles.css
// module id = ./css/styles.css
// module chunks = 0